import { Tooltip } from "@react95/core";
import { useApp } from "../../context/AppContext";

import {
  Inetcpl1314,
  Msnp32WrkgrpIcon,
  Msnsign100,
  MsnsignIcoApp,
  Rnaapp114,
  Rnaapp113,
  Mute,
  Mmsys101,
} from "@react95/icons";

export default function SoundTrayIcon() {
  const { status, error, volume, setVolume } = useApp();

  const mutedIcon = <Mute variant="16x16_4" />;
  const unmutedIcon = <Mmsys101 variant="16x16_4" />;

  const onClick = () => {
    if (volume > 0) setVolume(0);
    else setVolume(20);
  };

  return (
    <Tooltip text={`Sound: ${volume === 0 ? "Muted" : volume + "%"}`} onClick={onClick}>
      <div
        style={{
          width: "20px",
          height: "20px",
          cursor: "default",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {volume === 0 ? mutedIcon : unmutedIcon}
      </div>
    </Tooltip>
  );
}
